import { toast } from "react-toastify";
import freeResourceApi from "../../apis/freeResourceApi";
import {
  getResourcesFail,
  getResourcesSuccess,
  isPending,
  getSingleResourceSuccess,
} from "./freeResourceSlice";

export const fetchResourcesAction = () => async (dispatch) => {
  dispatch(isPending());

  const result = await freeResourceApi.fetchAllResources();

  if (Array.isArray(result)) {
    dispatch(getResourcesSuccess(result));
  } else if (result?.status === "success") {
    dispatch(getResourcesSuccess(result.resources || result.data || []));
  } else {
    dispatch(getResourcesFail(result?.message || "Failed to fetch resources"));
  }
};

export const deleteResourceAction = (id) => async (dispatch) => {
  dispatch(isPending());

  const result = await freeResourceApi.deleteAResource(id);

  if (result.status === "success") {
    toast.success(result.message);
    dispatch(fetchResourcesAction());
  } else {
    toast.error(result.message);
    dispatch(getResourcesFail(result.message));
  }
};

export const fetchSingleResourceAction = (id) => async (dispatch) => {
  dispatch(isPending());

  const result = await freeResourceApi.getAResource(id);

  if (result?._id || result?.status === "success") {
    dispatch(getSingleResourceSuccess(result.resource || result.data || result));
  } else {
    dispatch(getResourcesFail(result?.message || "Failed to fetch resource"));
  }
};
